var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _g10, _g11, _g12, _g13, _rect2, _path3, _g14, _rect3, _path4, _path5, _rect4, _g15, _g16, _path6, _rect5, _rect6, _g17, _g18, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 112,
    viewBox: "0 0 288 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 112,
    rx: 16,
    fill: "#F6F6F6",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.002 30.0286C118.002 30.0286 104.476 36.7573 103.374 42.6C101.944 50.1786 126.933 39.793 120.516 35.5143C119.145 34.6 116.402 36.4286 114.345 37.5715C110.145 39.9049 107.488 44.2 108.631 46.2572C110.892 50.3283 126.102 46.5722 122.802 43.2857C121.415 41.9042 119.145 43.2857 118.002 44.2C115.93 45.858 113.314 49.2522 115.259 51.0572C116.699 52.3928 121.591 50.7928 123.031 49.4572",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.514 34.1429V70.3869V102.714C122.514 107.764 126.608 111.857 131.657 111.857H160C165.049 111.857 169.143 107.764 169.143 102.714V34.1429C169.143 29.0935 165.049 25.0001 160 25.0001H131.657C126.608 25.0001 122.514 29.0935 122.514 34.1429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.743 70.3869V34.1429C122.743 29.2197 126.734 25.2286 131.657 25.2286H160C164.923 25.2286 168.914 29.2197 168.914 34.1429V102.714C168.914 107.638 164.923 111.629 160 111.629H131.657C126.734 111.629 122.743 107.638 122.743 102.714V70.3869Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.414 81.4744L117.046 108.701C117.288 110.518 118.838 111.874 120.671 111.874H139.243C139.243 111.874 138.786 103.417 136.271 99.5315C133.757 95.6458 129.871 95.8744 129.186 91.3029C128.5 86.7315 127.357 81.4744 126.671 78.5029C125.986 75.5315 125.757 71.6458 119.129 71.6458C112.5 71.6458 113.414 81.4744 113.414 81.4744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.273 108.671L113.642 81.449L113.641 81.4473L113.64 81.4274C113.638 81.4097 113.636 81.383 113.634 81.3479C113.629 81.2777 113.622 81.1741 113.616 81.0418C113.604 80.7771 113.595 80.3982 113.604 79.9431C113.621 79.0315 113.713 77.821 114.008 76.6143C114.303 75.4054 114.797 74.2182 115.608 73.3361C116.411 72.4615 117.536 71.8744 119.129 71.8744C122.395 71.8744 124.028 72.8286 124.943 74.094C125.723 75.1718 126.005 76.4943 126.28 77.7832C126.335 78.0424 126.39 78.3002 126.449 78.5543C127.134 81.5241 128.275 86.7743 128.96 91.3368C129.136 92.5139 129.521 93.392 130.044 94.1059C130.565 94.8167 131.216 95.3546 131.908 95.859C132.136 96.0251 132.368 96.1876 132.602 96.3517C133.799 97.1903 135.053 98.0685 136.08 99.6557C137.309 101.555 138.046 104.599 138.475 107.197C138.688 108.491 138.823 109.664 138.905 110.514C138.946 110.939 138.973 111.283 138.99 111.52C138.994 111.566 138.997 111.608 138.999 111.646H120.671C118.953 111.646 117.5 110.374 117.273 108.671Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.052 71.1886C172.892 71.1887 162.589 79.2728 161.426 81.1255C160.263 82.9781 160.762 84.4939 161.426 85.5044C162.091 86.5149 162.922 87.1886 164.916 87.1886C166.91 87.1886 174.03 82.3044 177.212 78.936C180.394 75.5676 177.212 71.1886 175.052 71.1886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62 81.247C161.751 81.0389 162.023 80.7254 162.419 80.328C162.811 79.9345 163.314 79.4704 163.893 78.9632C165.051 77.9491 166.511 76.7684 168.003 75.6449C169.495 74.5211 171.015 73.4574 172.294 72.6758C172.934 72.2848 173.51 71.9669 173.989 71.7474C174.478 71.5236 174.836 71.4172 175.052 71.4172C175.519 71.4172 176.072 71.6572 176.601 72.1006C177.126 72.5408 177.606 73.1648 177.926 73.8913C178.563 75.3372 178.564 77.1723 177.046 78.779C175.47 80.4467 172.91 82.4993 170.49 84.1362C169.282 84.954 168.113 85.6644 167.127 86.1694C166.633 86.4219 166.188 86.6213 165.809 86.757C165.425 86.8942 165.126 86.9601 164.916 86.9601C163.944 86.9601 163.279 86.7958 162.782 86.5248C162.287 86.2546 161.938 85.8665 161.617 85.3788C161.299 84.8945 161.027 84.2992 160.969 83.6115C160.911 82.9275 161.063 82.1344 161.62 81.247Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.861 81.7029C174.199 81.703 166.274 87.9393 165.379 89.3685C164.485 90.7977 164.868 91.967 165.379 92.7465C165.891 93.5261 166.53 94.0458 168.064 94.0458C169.598 94.0458 175.075 90.278 177.522 87.6795C179.97 85.081 177.522 81.7029 175.861 81.7029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.573 89.4898C165.67 89.3346 165.876 89.0963 166.181 88.79C166.481 88.4875 166.867 88.1304 167.312 87.7396C168.202 86.9582 169.324 86.0482 170.47 85.1822C171.617 84.3158 172.785 83.4963 173.767 82.8946C174.259 82.5935 174.699 82.3495 175.065 82.1814C175.441 82.0089 175.707 81.9315 175.861 81.9315C176.203 81.9315 176.617 82.1088 177.018 82.4463C177.416 82.7806 177.78 83.2554 178.023 83.8087C178.506 84.9083 178.507 86.3009 177.356 87.5228C176.148 88.8054 174.181 90.3864 172.322 91.6479C171.393 92.2781 170.497 92.8249 169.74 93.2131C169.362 93.4073 169.022 93.56 168.733 93.6637C168.44 93.7689 168.216 93.8172 168.064 93.8172C167.322 93.8172 166.82 93.6915 166.448 93.488C166.077 93.2852 165.815 92.9934 165.571 92.6212C165.329 92.2524 165.124 91.8014 165.08 91.2819C165.037 90.7662 165.15 90.1655 165.573 89.4898Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.271 38.7315C173.757 39.6458 169.186 42.8458 169.186 42.8458V56.103C169.186 56.103 178.557 50.8459 180.386 48.7887C182.214 46.7315 184.043 43.9887 182.671 41.0173C181.3 38.0458 178.786 37.8173 176.271 38.7315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.414 55.7111V42.9654C169.442 42.9458 169.477 42.9222 169.516 42.8949C169.646 42.806 169.833 42.6779 170.067 42.5213C170.533 42.2079 171.181 41.7807 171.907 41.3251C173.365 40.4101 175.118 39.3941 176.349 38.9464C177.582 38.4982 178.787 38.3409 179.838 38.6373C180.878 38.9307 181.802 39.6783 182.464 41.113C183.769 43.9407 182.046 46.576 180.215 48.6368C179.778 49.1276 178.872 49.8277 177.734 50.6112C176.604 51.39 175.265 52.2375 173.981 53.0222C172.697 53.8067 171.47 54.5272 170.564 55.0516C170.111 55.3138 169.738 55.5269 169.479 55.6744C169.456 55.6871 169.435 55.6994 169.414 55.7111Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.757 57.2458C170.786 57.2458 156.615 68.2172 155.014 70.7315C153.414 73.2458 154.1 75.3029 155.014 76.6744C155.929 78.0458 157.072 78.9601 159.815 78.9601C162.557 78.9601 172.352 72.3315 176.729 67.7601C181.106 63.1886 176.729 57.2458 173.757 57.2458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.207 70.8542C155.392 70.5634 155.773 70.1324 156.318 69.5927C156.86 69.0569 157.552 68.4257 158.35 67.7366C159.945 66.3587 161.955 64.755 164.008 63.2293C166.062 61.7032 168.155 60.2578 169.918 59.1951C170.8 58.6636 171.595 58.2302 172.259 57.9304C172.932 57.6264 173.439 57.4744 173.757 57.4744C174.428 57.4744 175.209 57.813 175.945 58.4219C176.677 59.0277 177.345 59.8849 177.79 60.8818C178.677 62.8681 178.678 65.3938 176.564 67.602C174.391 69.8713 170.863 72.6608 167.532 74.8843C165.867 75.9953 164.257 76.9615 162.896 77.6489C162.215 77.9927 161.6 78.2649 161.073 78.4508C160.542 78.6381 160.118 78.7315 159.815 78.7315C158.468 78.7315 157.537 78.507 156.837 78.1303C156.139 77.7543 155.65 77.2156 155.205 76.5476C154.761 75.8828 154.381 75.0622 154.299 74.112C154.218 73.1656 154.432 72.0723 155.207 70.8542Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.402,
    y: 30.0286,
    width: 10.9714,
    height: 3.65714,
    rx: 1.82857,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.631,
    y: 30.2572,
    width: 10.5143,
    height: 3.2,
    rx: 1.6,
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.491 47.8961V47.8961C151.491 48.1664 151.711 48.3856 151.981 48.3856H154.054C154.846 48.3856 155.488 49.0274 155.488 49.8192V49.8192C155.488 50.6109 154.846 51.2528 154.054 51.2528H152.841C151.944 51.2528 151.201 51.9113 150.937 52.7689C150.668 53.6444 150.302 54.3861 149.838 54.9941C149.148 55.9032 148.161 56.5675 146.875 56.9871C145.995 57.258 144.939 57.4362 143.706 57.522C142.699 57.592 141.879 58.4002 141.879 59.4101V59.7844C141.879 61.0664 142.143 62.0804 142.671 62.8264C143.222 63.5723 144.141 63.9453 145.427 63.9453C147.177 63.9453 148.273 63.1982 148.716 61.7042C148.999 60.7511 149.748 59.9242 150.742 59.9242V59.9242C151.743 59.9242 152.575 60.7474 152.403 61.7334C152.144 63.2142 151.564 64.3944 150.664 65.274C149.447 66.4628 147.678 67.0572 145.359 67.0572C143.039 67.0572 141.259 66.4045 140.018 65.0991C138.801 63.7938 138.192 61.9639 138.192 59.6095V56.6478C138.192 55.6379 139.011 54.8219 140.021 54.8054C141.658 54.7788 142.92 54.7134 143.808 54.6095C145.003 54.4463 145.887 54.1199 146.461 53.6304C146.6 53.5167 146.727 53.3866 146.844 53.2402C147.547 52.3552 146.602 51.2528 145.472 51.2528H138.179C137.387 51.2528 136.745 50.6109 136.745 49.8192V49.8192C136.745 49.0274 137.387 48.3856 138.179 48.3856H147.315C147.586 48.3856 147.805 48.1664 147.805 47.8961V47.8961V47.1022C147.805 46.0923 146.986 45.2736 145.976 45.2736H138.196C137.395 45.2736 136.745 44.624 136.745 43.8226V43.8226C136.745 43.0212 137.395 42.3715 138.196 42.3715H154.037C154.838 42.3715 155.488 43.0212 155.488 43.8226V43.8226C155.488 44.624 154.838 45.2736 154.037 45.2736H153.32C152.31 45.2736 151.491 46.0923 151.491 47.1022V47.8961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.656 54.8553L149.655 54.856C149 55.7211 148.055 56.3613 146.805 56.7692C145.948 57.0332 144.911 57.2091 143.69 57.2939C142.574 57.3716 141.65 58.2696 141.65 59.4101V59.7844C141.65 61.0953 141.92 62.1612 142.485 62.9585L142.485 62.9585L142.487 62.9622C143.097 63.787 144.099 64.1738 145.427 64.1738C146.333 64.1738 147.094 63.9803 147.69 63.5739C148.289 63.1657 148.701 62.5575 148.935 61.7692C149.202 60.8689 149.888 60.1528 150.742 60.1528C151.63 60.1528 152.321 60.8749 152.178 61.694C151.925 63.1371 151.364 64.2706 150.505 65.1105C149.344 66.2443 147.641 66.8286 145.359 66.8286C143.083 66.8286 141.37 66.1898 140.185 64.9425C139.018 63.6915 138.421 61.9245 138.421 59.6095V56.6478C138.421 55.7653 139.137 55.0484 140.025 55.034C141.664 55.0073 142.935 54.9418 143.835 54.8365L143.835 54.8365L143.839 54.8359C145.052 54.6702 145.986 54.3351 146.608 53.8058C146.759 53.6817 146.897 53.5404 147.023 53.3825C147.45 52.8451 147.37 52.2322 147.029 51.7775C146.695 51.3326 146.108 51.0242 145.472 51.0242H138.179C137.513 51.0242 136.974 50.4847 136.974 49.8192C136.974 49.1537 137.513 48.6141 138.179 48.6141H147.315C147.712 48.6141 148.033 48.2926 148.033 47.8961V47.1022C148.033 45.9661 147.112 45.0451 145.976 45.0451H138.196C137.521 45.0451 136.974 44.4977 136.974 43.8226C136.974 43.1474 137.521 42.6001 138.196 42.6001H154.037C154.712 42.6001 155.259 43.1474 155.259 43.8226C155.259 44.4977 154.712 45.0451 154.037 45.0451H153.32C152.184 45.0451 151.263 45.9661 151.263 47.1022V47.8961C151.263 48.2926 151.584 48.6141 151.981 48.6141H154.054C154.72 48.6141 155.259 49.1537 155.259 49.8192C155.259 50.4847 154.72 51.0242 154.054 51.0242H152.841C151.825 51.0242 151.006 51.7675 150.719 52.7018C150.456 53.5564 150.101 54.2727 149.656 54.8553Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.675 89.3601L136.532 81.8706C136.389 81.5317 136.685 81.1721 137.045 81.2458L141.6 82.1791C141.849 82.2302 142.008 82.4746 141.955 82.7232L140.544 89.2794C140.45 89.7166 139.848 89.7725 139.675 89.3601Z",
    fill: "#021317",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.036 81.5389L138.394 80.0081C138.252 79.6693 138.547 79.3096 138.907 79.3833L143.462 80.3166C143.711 80.3677 143.871 80.6121 143.817 80.8607L142.406 87.4169C142.312 87.8541 141.711 87.91 141.538 87.4976L141.122 86.5084",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.746 100.374C155.169 101.951 153.11 102.448 152.145 101.484C151.181 100.52 151.679 98.4607 153.256 96.8839C154.832 95.307 156.892 94.8095 157.856 95.7737C158.82 96.738 158.323 98.7972 156.746 100.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.584 100.212C155.821 100.976 154.948 101.47 154.162 101.66C153.373 101.851 152.712 101.727 152.307 101.323C151.903 100.918 151.779 100.257 151.97 99.4674C152.159 98.6822 152.654 97.8092 153.417 97.0455C154.181 96.2818 155.054 95.7876 155.839 95.5981C156.629 95.4074 157.29 95.5308 157.694 95.9354C158.099 96.3399 158.222 97.0009 158.032 97.7906C157.842 98.5758 157.348 99.4488 156.584 100.212Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.5259 41.8294C57.8356 43.2365 54.9577 43.0451 54.0973 41.4C53.2368 39.7548 54.721 37.2818 57.4113 35.8746C60.1017 34.4675 62.9795 34.6589 63.84 36.304C64.7005 37.9492 63.2163 40.4222 60.5259 41.8294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.42 41.6268C59.1059 42.3142 57.7555 42.6056 56.6406 42.5312C55.5212 42.4566 54.6792 42.0194 54.2998 41.294C53.9204 40.5687 54.0416 39.6277 54.6187 38.6656C55.1935 37.7075 56.2031 36.7645 57.5173 36.0772C58.8314 35.3898 60.1818 35.0984 61.2967 35.1728C62.4161 35.2475 63.2581 35.6846 63.6375 36.41C64.0169 37.1353 63.8957 38.0763 63.3185 39.0384C62.7437 39.9965 61.7341 40.9395 60.42 41.6268Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8333 27.3197C41.3153 24.6904 41.3866 21.807 42.9945 20.8787C44.6023 19.9504 47.135 21.3303 48.6531 23.9597C50.1712 26.5891 50.0998 29.4724 48.492 30.4007C46.8841 31.329 44.3514 29.9491 42.8333 27.3197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0313 27.2055C42.2898 25.9211 41.9423 24.584 41.9702 23.467C41.9981 22.3455 42.3998 21.486 43.1087 21.0767C43.8176 20.6674 44.7629 20.7493 45.7481 21.2858C46.7294 21.8202 47.7136 22.7896 48.4552 24.074C49.1967 25.3583 49.5441 26.6954 49.5163 27.8124C49.4883 28.9339 49.0866 29.7935 48.3777 30.2027C47.6688 30.612 46.7236 30.5302 45.7383 29.9936C44.757 29.4592 43.7728 28.4898 43.0313 27.2055Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7037 50.1687C40.0743 48.6506 38.6944 46.1179 39.6227 44.51C40.551 42.9022 43.4344 42.8308 46.0637 44.3489C48.6931 45.8669 50.073 48.3997 49.1447 50.0075C48.2164 51.6154 45.333 51.6867 42.7037 50.1687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.818 49.9707C41.5336 49.2292 40.5642 48.245 40.0298 47.2637C39.4933 46.2784 39.4114 45.3332 39.8207 44.6243C40.23 43.9154 41.0895 43.5137 42.211 43.4857C43.328 43.4579 44.6651 43.8053 45.9494 44.5468C47.2338 45.2883 48.2032 46.2726 48.7376 47.2538C49.2741 48.2391 49.356 49.1843 48.9467 49.8932C48.5374 50.6021 47.6779 51.0038 46.5564 51.0318C45.4394 51.0597 44.1023 50.7122 42.818 49.9707Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.002,
    y: 63.492,
    width: 43.54,
    height: 26.54,
    rx: 3.43,
    transform: "rotate(15 29.002 63.492)",
    fill: "white",
    stroke: "#021317",
    strokeWidth: 0.46
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5881 74.9366L26.132 65.4429C26.9161 62.5164 29.9241 60.7798 32.8506 61.5639L66.6304 70.6152C68.0936 71.0073 68.9619 72.5113 68.5698 73.9745V73.9745M21.4362 82.9675L21.346 83.3043C20.9833 84.6577 21.7866 86.0489 23.14 86.4116V86.4116",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6624 84.4357L22.8311 82.0693C21.3069 81.6609 20.4024 80.0942 20.8108 78.5701C21.2192 77.0459 22.7859 76.1413 24.3101 76.5498L33.1414 78.9161C34.6656 79.3245 35.5701 80.8912 35.1617 82.4154C34.7533 83.9396 33.1866 84.8441 31.6624 84.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7216 84.2149L22.8903 81.8485C21.488 81.4728 20.6559 80.0315 21.0316 78.6292C21.4073 77.227 22.8487 76.3948 24.2509 76.7705L33.0822 79.1369C34.4845 79.5126 35.3167 80.954 34.9409 82.3562C34.5652 83.7585 33.1238 84.5906 31.7216 84.2149Z",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.7148,
    y: 71.7513,
    width: 4,
    height: 27,
    transform: "rotate(15 60.7148 71.7513)",
    fill: "#021317"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.985 52.505V52.505C220.41 54.0902 222.039 55.0309 223.624 54.6061L257.404 45.5549C259.355 45.0321 260.513 43.0268 259.99 41.0758L254.902 22.0885C254.51 20.6252 253.006 19.7569 251.543 20.149V20.149",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.448 49.9032L211.597 31.799C211.074 29.848 212.232 27.8427 214.183 27.3199L247.3 18.4461C249.251 17.9234 251.257 19.0812 251.779 21.0321L256.63 39.1363C257.153 41.0873 255.995 43.0927 254.044 43.6154L220.927 52.4892C218.976 53.012 216.971 51.8542 216.448 49.9032Z",
    fill: "white",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 218.84,
    y: 43.8195,
    width: 6.85714,
    height: 3.2,
    rx: 1.6,
    transform: "rotate(-15 218.84 43.8195)",
    fill: "white",
    stroke: "#021317",
    strokeWidth: 0.457143
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.539,
    y: 34.7167,
    width: 41.6,
    height: 5.48571,
    rx: 2.74286,
    transform: "rotate(-15 209.539 34.7167)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.819,
    y: 34.8783,
    width: 41.1429,
    height: 5.02857,
    rx: 2.51429,
    transform: "rotate(-15 209.819 34.8783)",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210.65,
    cy: 28.2664,
    r: 3.65714,
    transform: "rotate(-15 210.65 28.2664)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.65,
    cy: 28.2664,
    r: 3.42857,
    transform: "rotate(-15 210.65 28.2664)",
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.744 28.6589L210.424 29.6286L212.283 26.4093",
    stroke: "#021317",
    strokeWidth: 0.457143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 239.086,
    y: 77.257,
    width: 7.31429,
    height: 7.31429,
    rx: 2.74286,
    fill: "#021317"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256.152,
    y: 94.3237,
    width: 4.87619,
    height: 4.87619,
    rx: 1.82857,
    fill: "#021317"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 239.086,
    y: 91.8856,
    width: 7.31429,
    height: 7.31429,
    rx: 2.74286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.315,
    y: 92.1142,
    width: 6.85714,
    height: 6.85714,
    rx: 2.51429,
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_6851_25626)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.714,
    y: 77.257,
    width: 7.31429,
    height: 7.31429,
    rx: 2.74286,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.943,
    y: 77.4856,
    width: 6.85714,
    height: 6.85714,
    rx: 2.51429,
    stroke: "#021317",
    strokeWidth: 0.457143
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.029 91.8856H256.457C254.942 91.8856 253.714 93.1136 253.714 94.6284V99.1999",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.657 88.2285H247.314C248.829 88.2285 250.057 87.0004 250.057 85.4856V81.3713",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M253.714 88.2285L257.829 88.2285",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.657 88.2285H261.181",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.086 88.2285H241.219",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250.057 77.7142V79.5427",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250.057 91.8856V96.457",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250.057 98.2856L250.057 99.1999",
    stroke: "#021317",
    strokeWidth: 0.914286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6851_25626",
    x: 103.086,
    y: 29.8,
    width: 20.4111,
    height: 22.4458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.457143
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6851_25626",
    x: 122.514,
    y: 23.1715,
    width: 46.6284,
    height: 88.6857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.82857
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6851_25626",
    x: 113.372,
    y: 70.7315,
    width: 25.8716,
    height: 41.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6851_25626",
    x: 160.729,
    y: 71.1886,
    width: 17.8286,
    height: 16.9143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6851_25626",
    x: 164.843,
    y: 81.7029,
    width: 13.7144,
    height: 13.2572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6851_25626",
    x: 169.186,
    y: 38.2572,
    width: 13.9644,
    height: 18.76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6851_25626",
    x: 154.055,
    y: 57.2458,
    width: 24.5244,
    height: 22.6286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6851_25626",
    x: 140.402,
    y: 30.0286,
    width: 10.9712,
    height: 4.57142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_6851_25626",
    x: 136.745,
    y: 42.3715,
    width: 18.7427,
    height: 25.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_6851_25626",
    x: 151.654,
    y: 95.282,
    width: 7.60813,
    height: 7.60829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.914286,
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_6851_25626",
    x: 53.853,
    y: 34.9329,
    width: 11.1457,
    height: 8.75251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.914286,
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_6851_25626",
    x: 40.8259,
    y: 20.5895,
    width: 8.92063,
    height: 11.0148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.914286,
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_6851_25626",
    x: 38.4192,
    y: 43.2556,
    width: 11.0149,
    height: 8.9206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.914286,
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_6851_25626",
    x: 20.7129,
    y: 76.4517,
    width: 14.5469,
    height: 8.99635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_6851_25626",
    x: 210.155,
    y: 24.5656,
    width: 40.3706,
    height: 15.7485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_6851_25626",
    x: 206.992,
    y: 24.6084,
    width: 7.31641,
    height: 8.23039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_6851_25626",
    x: 239.086,
    y: 91.8856,
    width: 7.31445,
    height: 8.22859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_6851_25626",
    x: 253.714,
    y: 77.257,
    width: 7.31445,
    height: 8.22859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.914286
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6851_25626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6851_25626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalPay);
export default __webpack_public_path__ + "static/media/personal-pay.83aba288824c80bd80182736635b3f7e.svg";
export { ForwardRef as ReactComponent };